const initialState = {
  allCityConfigs: {},
  cityAgencies: [],

};
export default initialState;
